// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
import { MenuItemLink } from "react-admin";

const CustomMenuItemLink = styled(MenuItemLink)({
  "&.MuiMenuItem-root": {
    fontFamily: "Proxima Nova",
    // padding:'12px 1em 12px 1em',
    // padding: "8px 1em 8px 1em",
    padding: "5px 0.2em 5px 0.2em",
    fontSize: "1rem",
    color: "gray",
    borderLeft: "none",
    paddingLeft: "10px",
  },
  "&.Mui-selected": {
    borderLeft: "none",
    // color: "gray",
    color: "black",
    backgroundColor: "rgba(25, 118, 210, 0.20)",
  },
  "&.Mui-disabled": {
    // backgroundColor: "red",
  },
  "&.menuTitle": {
    color: "grey",
    opacity: 1,
    backgroundColor: "#e5e5e5",
  },
});

export default CustomMenuItemLink;
